<div class="no-data-container" id="{{ cardStyle }}">
    <div class="no-data-card-title" *ngIf="showTitle">
        {{ componentTitle }}
    </div>
    <div *ngIf="showImage" class="no-data-image-area">
        <img class="no-data-img" src="{{ logoPlaceholderPath }}" />
    </div>
    <div class="{{ noDataHeaderMessage }}">
        <span>{{ headerMessage }}</span>
    </div>
    <div class="no-data-body-message" *ngIf="!customMessage">
        <div *ngFor="let messageLine of bodyMessage">{{ messageLine }}</div>
    </div>
    <div class="no-data-body-message" *ngIf="customMessage">
        <div *ngIf="customMessage">{{ customMessage }}</div>
    </div>
</div>
